<mat-form-field [formGroup]="form" appearance="fill">
  <mat-label>Search for Verified Address</mat-label>
  <input
    #addressInput
    matInput
    type="text"
    class="address-autocomplete-input"
    [placeholder]="placeholder"
    [disabled]="isDisabled"
    [value]="inputValue"
    (input)="onInputChange($event)"
    (blur)="onTouched()"
    [formControlName]="formControlName"
    autocomplete="off"
  />
</mat-form-field>
